<script setup>
// refs
const visible = ref(false)

// store
const store = useLoginStore()

const show = () => { visible.value = true }
const hide = () => { visible.value = false }

const confirm = () => {
  hide()
}

defineExpose({ show, hide })
</script>

<template>
  <Dialog
    v-model:visible="visible" name="qrcodeModal"
    :modal="true"
    :closable="false"
    class="w-md-50 w-100 m-4"
  >
    <template #header>
      <div class="fw-bold fs-4">
        <i class="fas fa-qrcode " />
        <span>&nbsp;QRCode</span>
      </div>
    </template>
    <div class="text-center p-4">
      <img :src="store.qrcode.picbase64" alt="Base64 Image">
    </div>
    <template #footer>
      <Button class="flex-grow-1 p-3 justify-content-center text-white" size="large" severity="warn" type="button" @click="confirm">
        Confirm
      </Button>
    </template>
  </Dialog>
</template>
